<template>
    <div class="login-container">
        <div class="login-form">
            <div class="card card-login">
                <div class="card-header">
                    <a href="#" class="logo-link">
                        <img src="@/assets/img/logo_jtb_wht@2x.png" alt="Logo" />
                    </a>
                    <div class="text-login">{{$t('general.system_name')}}</div>
                </div>
                <form @submit.prevent="handleSubmit">
                    <div class="card-body">
                        <div class="fs-18 mb-2">{{$t('change_pass.title')}}</div>

                        <div class="error-message" v-if="errorMessage">
                            <div class="d-flex">
                                <i class="icon-warning mr-2"></i>
                                <div class="errror-txt">
                                    <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                                    <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="form-box">
                            <div class="form-group">
                                <div class="form-input">
                                    <i class="icon-left icon-lock-red"></i>
                                    <input
                                        :type="typeInputPass"
                                        class="form-control"
                                        v-bind:placeholder="$t('change_pass.password')"
                                        name="password"
                                        v-model="password"
                                        v-validate="{required: true,regex:/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[<>{}()\-+*/_!$%&#?@;:,.])[a-zA-Z0-9<>{}()\-+*/_!$%&#?@;:,.]{8,}$/}"
                                        ref="password"
                                        :data-vv-as="$t('change_pass.password')"
                                    />
                                    <span :class="showHidePass" @click="showPassword">
                                        <i class="icon-eye"></i>
                                    </span>

                                    <span data-toggle="tooltip" data-placement="left"
                                        title="- 8文字以上
                                            - 半角英字(大文字、小文字)、半角数字、記号(下記)
                                            - 記号 <>{}()-+*/_!$%&#?@;:,.
                                            - 大文字を1文字以上含める
                                            - 数字を1文字以上含める
                                            - 記号を1文字以上含める
                                            - ユーザーIDは使用できません
                                            - 前回と同じパスワードは使用できません"
                                        class="help_change_pass fa fa-question-circle" aria-hidden="true">
                                    </span>

                                </div>
                                <span class="error-text" v-if="errors.has('password')">{{errors.first('password')}}</span>
                            </div>

                            <div class="form-group">
                                <div class="form-input">
                                    <i class="icon-left icon-lock-red"></i>
                                    <input
                                        :type="typeInputConfirm"
                                        class="form-control"
                                        v-bind:placeholder="$t('change_pass.confirm')"
                                        name="confirm"
                                        v-model="confirm"
                                        v-validate="'required|confirmed:password'"
                                        :data-vv-as="$t('change_pass.password')"
                                    />
                                    <span :class="showHideConfirm" @click="showConfirm">
                                        <i class="icon-eye"></i>
                                    </span>
                                </div>
                                <span class="error-text" v-if="errors.has('confirm')">{{errors.first('confirm')}}</span>
                            </div>
                            <div v-show="!clickChangePass" class="mt-50">
                                <button class="btn btn-login">{{$t('button.ok')}}</button>
                            </div>
                            <div v-show="clickChangePass" class="row no-gutters w-100 mt-50">
                                <div class="col-6">
                                    <button class="btn btn-login">{{$t('button.ok')}}</button>
                                </div>
                                <div class="col-6 pl-1">
                                    <button class="btn btn-gray-53 btn-back" type="button" @click="back">{{$t('button.back')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
/* global $ */
import { AuthService } from "@/services/common/auth.service";
import StorageService from "@/services/common/storage.service";
import Utils from '@/helpers/utils';
export default {
    name: "PcResetPassword",
    data () {
        return {
            password: "",
            confirm: "",
            submitted: false,
            typeInputPass: "password",
            showHidePass: "",
            typeInputConfirm: "password",
            showHideConfirm: "",
            cssShowHide: "btn-show-hide fn-show-hide",
            errorMessage: "",
            clickChangePass: false,
            username: "",
            placeId: "",
        };
    },
    computed: {},
    created () {},
    beforeMount () {
        this.showHidePass = this.cssShowHide;
        this.showHideConfirm = this.cssShowHide;
        this.clickChangePass = StorageService.getClickChangePass() ? true : false;
    },
    mounted () {
        $('[data-toggle="tooltip"]').tooltip();
        this.username = this.$route.query.username;
        this.placeId = this.$route.query.placeId;
    },
    beforeDestroy () {
        StorageService.removeClickChangePass();
    },
    methods: {
        handleSubmit (e) {
            this.submitted = true;
            this.$validator.validate().then(valid => {
                if (valid) {
                    AuthService.changePassword(this.password, this.username, this.placeId, this.clickChangePass)
                        .then(response => {
                            if (response.status == 423) {
                                StorageService.saveExpired();
                                AuthService.doLogout();
                            }
                            if (response.status != 200) {
                                let errorCode = Utils.getErrorCode(response);
                                if (errorCode) {
                                    this.errorMessage = this.$root.$t("error.error_code_" + errorCode);
                                }
                            }
                        })
                        .catch(error => {
                            this.errorMessage = this.$root.$t("fail.change_pass_fail");
                        });
                }
            });
        },
        showPassword () {
            if (this.typeInputPass == "password") {
                this.showHidePass = this.cssShowHide + " ex-show-password";
                this.typeInputPass = "text";
            } else {
                this.showHidePass = this.cssShowHide;
                this.typeInputPass = "password";
            }
        },
        showConfirm () {
            if (this.typeInputConfirm == "password") {
                this.showHideConfirm = this.cssShowHide + " ex-show-password";
                this.typeInputConfirm = "text";
            } else {
                this.showHideConfirm = this.cssShowHide;
                this.typeInputConfirm = "password";
            }
        },
        back () {
            AuthService.logout();
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/ResetPassword/ResetPassword.vue